<div class="notification-container" [style.visibility]="showNotification ? 'visible' : 'hidden'" (click)="onDismiss()">
    <div class="notification" [class]='incommingNotification.type'>{{ incommingNotification.message }}</div>
    <img class="close-icon" [src]="'assets/icons/close_icon.svg'"/>
</div>